import * as Yup from "yup";

export const graduationStatisticsSchema = Yup.object().shape({
  institution_id: Yup.string().required("Institution is required"),
  session_id: Yup.string().required("Session is required"),
  academic_program_level_stats: Yup.array().of(
    Yup.object().shape({
      academic_program_level_id: Yup.string().required(
        "Program Level is required"
      ),

      male_count: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Humanities Male Count must be a number")
        .required("Humanities Male Count is required")
        .min(0, "Humanities Male Count cannot be negative"),

      female_count: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Humanities Female Count must be a number")
        .required("Humanities Female Count is required")
        .min(0, "Humanities Female Count cannot be negative"),

      sciences_male_count: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Sciences Male Count must be a number")
        .required("Sciences Male Count is required")
        .min(0, "Sciences Male Count cannot be negative"),

      sciences_female_count: Yup.number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .typeError("Sciences Female Count must be a number")
        .required("Sciences Female Count is required")
        .min(0, "Sciences Female Count cannot be negative"),
    })
  ),
});
